const P = process.env.PUBLIC_URL || '';

/** ASCII paths under `public/lobby-home/` (копии из «главная готовая»). */
export const LOBBY_HOME_ASSETS = {
  bgLobbyHeader: `${P}/lobby-home/bg_lobby_header.svg`,
  decHeaderRail: `${P}/lobby-home/dec_header_rail.svg`,
  frameAvatar: `${P}/lobby-home/frame_avatar.svg`,
  iconStarLevel: `${P}/lobby-home/icon_star_level.svg`,
  frameGlobalChat: `${P}/lobby-home/frame_global_chat.svg`,
  decKrug1: `${P}/lobby-home/dec_krug_1.svg`,
  decKrug2: `${P}/lobby-home/dec_krug_2.svg`,
  btnCigarettes: `${P}/lobby-home/btn_cigarettes.svg`,
  btnCalendar: `${P}/lobby-home/btn_calendar.svg`,
  btnBucks: `${P}/lobby-home/btn_bucks.svg`,
  btnMail: `${P}/lobby-home/btn_mail.svg`,
  btnClans: `${P}/lobby-home/btn_clans.svg`,
  /** Середина лобби */
  btnSekaTables: `${P}/lobby-home/btn_seka_tables.svg`,
  btnBelotTables: `${P}/lobby-home/btn_belot_tables.svg`,
  btnPlayBots: `${P}/lobby-home/btn_play_bots.svg`,
  btnOnlineNetwork: `${P}/lobby-home/btn_online_network.svg`,
  btnRefreshRooms: `${P}/lobby-home/btn_refresh_rooms.svg`,
  btnCreateTable: `${P}/lobby-home/btn_create_table.svg`,
  /** Пустой список столов — фон из макета */
  bgNoOpenRooms: `${P}/lobby-home/bg_no_open_rooms.svg`,
  /** Нижний навбар */
  btnPodgonyBratva: `${P}/lobby-home/btn_podgony_bratva.svg`,
  btnCreateRoomNav: `${P}/lobby-home/btn_create_room_nav.svg`,
  btnBratvaNav: `${P}/lobby-home/btn_bratva_nav.svg`,
  /** Декор над кнопками (макет 393×839: подарок слева, дверь над «Создать») */
  decNavGift: `${P}/lobby-home/dec_nav_gift.svg`,
  decNavDoor: `${P}/lobby-home/dec_nav_door.svg`,
  bgNavZadnijfon: `${P}/lobby-home/bg_nav_zadnijfon.svg`,
  /** Текстура как header-ramka — фон нижнего дока (SVG с заливкой) */
  decBottomNavRamka: `${P}/lobby-home/dec_bottom_nav_ramka.svg`,
};
